import React from 'react';

export const UserAgentMessage = () => {
  return (
    <p>
      L'utilisation de votre navigateur n'est pas la plus adaptée à notre
      application. Préférez les dernières versions de Chrome, Mozilla ou Safari
      (pour Apple). Vous risquez de rencontrer des difficultés sur
      l'application.
    </p>
  );
};
